import { Link } from 'react-router-dom';
import Logo from '../Logo';
import { useAuth } from '../../contexts/AuthContext';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { isAdmin } = useAuth();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <Logo variant="icon" color="full-color" size="lg" />
            <p className="text-sm text-gray-600 text-center md:text-left max-w-xs">
              Helping electrical contractors calculate permit fees instantly.
            </p>
          </div>

          {/* Product Links */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">
              Product
            </h3>
            <nav className="flex flex-col items-center md:items-start gap-2">
              <Link
                to="/product"
                className="text-sm text-gray-600 hover:text-primary transition-colors"
              >
                Product
              </Link>
              <Link
                to="/report-problem"
                className="text-sm text-gray-600 hover:text-primary transition-colors"
              >
                Report a Problem
              </Link>
            </nav>
          </div>

          {/* Company Links */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">
              Company
            </h3>
            <nav className="flex flex-col items-center md:items-start gap-2">
              <Link
                to="/about"
                className="text-sm text-gray-600 hover:text-primary transition-colors"
              >
                About Us
              </Link>
              <Link
                to="/contact"
                className="text-sm text-gray-600 hover:text-primary transition-colors"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Legal Links */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">
              Legal
            </h3>
            <nav className="flex flex-col items-center md:items-start gap-2">
              <Link
                to="/privacy"
                className="text-sm text-gray-600 hover:text-primary transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-sm text-gray-600 hover:text-primary transition-colors"
              >
                Terms of Service
              </Link>
            </nav>
          </div>
        </div>

        {/* Admin Links - Only visible to admins */}
        {isAdmin && (
          <div className="mb-8 pt-4 border-t border-gray-200">
            <div className="flex flex-col items-center md:items-start gap-3">
              <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">
                Admin Tools
              </h3>
              <nav className="flex flex-col items-center md:items-start gap-2">
                <Link
                  to="/admin"
                  className="text-sm text-gray-600 hover:text-primary transition-colors"
                >
                  Admin Panel
                </Link>
              </nav>
            </div>
          </div>
        )}

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-600 text-center">
            &copy; {currentYear} euronymo · PermitBuddy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
